import { defineMessages } from 'react-intl';

const trns = defineMessages({
  productReviews: {
    id: 'Kj1Y8Y',
    defaultMessage: 'Відгуки про товар'
  },
  fromDate: {
    id: 'gxdXfV',
    defaultMessage: 'від'
  },
  loadMoreReviews: {
    id: 'TYWMJV',
    defaultMessage: 'ЗАВАНТАЖИТИ ЩЕ'
  },
  noProductReviewsYet: {
    id: 'A71tZp',
    defaultMessage:
      'Ще немає відгуків про товар.Будь першим, хто залишить відгук.'
  },
  LeaveReview: {
    id: 'gh7f5e',
    defaultMessage: 'Залишити відгук'
  },
  writeReview: {
    id: 'p/AfUI',
    defaultMessage: 'Написати відгук'
  },
  yourReviewHelps: {
    id: 'IcmepJ',
    defaultMessage:
      'Ваш відгук допоможе зробити вибір. Дякуємо, що ділитеся досвідом!'
  },
  yourName: {
    id: '0d0d8h',
    defaultMessage: 'Ваше ім’я'
  },
  requiredFieldLabel: {
    id: 'H7lCKm',
    defaultMessage: 'Обов’язкове поле'
  },
  minimumLength5: {
    id: 'rwGPId',
    defaultMessage: 'Мінімальна довжина 5 символів'
  },
  minimumLength3: {
    id: 'TZvKzz',
    defaultMessage: 'Мінімальна довжина 3 символів'
  },
  maxmumLength30: {
    id: '/ZvrQu',
    defaultMessage: 'Максимальна довжина 30 символів'
  },
  importantly: {
    id: 'DxoB2B',
    defaultMessage:
      'Важливо! Щоб ваш відгук пройшов модерацію та був опублікований, ознайомтесь, будь-ласка, з правилами'
  },
  cancel: {
    id: 'JI8c75',
    defaultMessage: 'Відмінити'
  },
  rateProduct: {
    id: '/84nCF',
    defaultMessage: 'Оцініть товар'
  },
  describeExperience: {
    id: 'POpR+K',
    defaultMessage: 'Опишіть ваш досвід'
  },
  feedbackSuccess: {
    id: 'wdr41+',
    defaultMessage: 'Відгук успішно відправлений'
  },
  feedbackWillAppear: {
    id: 'MZoJxV',
    defaultMessage:
      'Ваш відгук з’явиться тут в разі успішного проходження модерації'
  },
  failedFeedback: {
    id: 'k5m4ZW',
    defaultMessage: 'Не вдалось відправити відгук'
  },
  tryAgainPlease: {
    id: 'bsTm89',
    defaultMessage: 'Спробуйте ще раз, будь ласка'
  },
  tryAgain: {
    id: 'uUKVWj',
    defaultMessage: 'Спробувати ще раз'
  },
  ok: {
    id: '+Zc9Ke',
    defaultMessage: 'ОК'
  },
  toLeaveReview: {
    id: 'FNXZIR',
    defaultMessage:
      'Щоб залишити відгук, перейдіть на сторінку товару і залиште відгук, який допоможе іншим зробити правильний вибір.'
  }
});

export default trns;
